import { render, staticRenderFns } from "./MessagePreviewServicePurchase.vue?vue&type=template&id=445af747&"
import script from "./MessagePreviewServicePurchase.vue?vue&type=script&lang=ts&"
export * from "./MessagePreviewServicePurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports